<template>
  <div class="bar-chart">
    <div class="is-clearfix">
      <!-- Star Filter Beg you guys available for the schedins -->
      <star-rating-filter
        @onRatingFilterChange="handleStarRatingFilter"
        class="rating-filter"
        dataTrack="Review Analytics select star rating"
      >
      </star-rating-filter>
      <!-- Star Filter Ends -->

      <div class="bar-chart-total-reviews is-clearfix" v-if="bizSources.length">
        <span class="margin-right-15 is-pulled-left">Review source- </span>
        <div class="is-clipped margin-right-35">
          <colored-checkbox :color="source.color"
                            :key="source.label"
                            :styleObj="source.styleObj || ``"
                            :is-checked="selectedSources.findIndex(s => s.source === source.source) > -1"
                            @cb-toggle="sourceToggle($event, source)"
                            class="margin-right-15 margin-bottom-10"
                            v-for="source in bizSources" >
            <span class="checkbox-label">{{source.label}}</span>
          </colored-checkbox>
        </div>
      </div>
    </div>
    <div v-if="canFetchData" class="has-spinner">
      <img class="has-spinner__spinner" src="/static/img/spinner.svg" v-if="isLoading">
      <vue-chart
        v-if="!isLoading"
        :columns="chartColumns"
        :key="keyIdx"
        :options="chartOptions"
        :rows="('reviewDetailedStats' in analyticsData)?analyticsData.reviewDetailedStats:[]"
        chart-type="ColumnChart"
      >
      </vue-chart>
    </div>
    <div class="noGraph" v-else>
      Please select a source and a star rating from the options above
    </div>
  </div>
</template>

<script>
  /* eslint-disable indent,no-new,no-undef,valid-jsdoc,one-var */
  import {mapState, mapActions} from 'vuex'
  import {StarRatingFilter, ColoredCheckbox} from '@/components'
  import {
    FETCH_REVIEW_ANALYTICS_GRAPH
  } from '@/store/action.types'
  import axios from 'axios'
  import {misc, charts} from '@/mixins'

  export default {
    name: 'ReviewDetailedStats',
    metaInfo: {
      title: 'Business Portal | Hellopeter - Review Analytics'
    },
    mixins: [misc, charts],
    components: {
      ColoredCheckbox,
      StarRatingFilter
    },
    props: {
      dateFilter: {
        type: Object,
        required: true
      },
      replyTime: {
        type: Object,
        required: true
      }
    },
    data () {
      return {
        loadingIndex: 0,
        requestCount: 0,
        starRating: null,
        bizSources: [],
        selectedSources: []
      }
    },
    mounted () {
      this.chartOptions['bar'] = {
        groupWidth: '38%'
      }
      this.chartOptions['isStacked'] = true
      this.chartOptions['series'] = {}

      const localSources = localStorage.getItem('bizSources')
      if (typeof localSources !== 'undefined' && localSources !== null && localSources.length > 0) {
        const bizSources = JSON.parse(localSources)
        this.bizSources = bizSources
        this.selectedSources = JSON.parse(JSON.stringify(bizSources))
      } else {
        axios.get(`/${this.businessSlug}/reviews/sources`)
          .then(({data}) => {
            const bizSources = []
            for (let source in this.allSources) {
              if (data.source.includes(source)) {
                bizSources.push({
                  source,
                  'label': this.allSources[source]['label'],
                  color: this.allSources[source]['color'],
                  styleObj: this.allSources[source]['styleObj'] || {}
                })
              }
            }
            this.bizSources = bizSources
            this.selectedSources = JSON.parse(JSON.stringify(bizSources))
            localStorage.setItem('bizSources', JSON.stringify(bizSources))
          })
      }
    },
    computed: {
      ...mapState({
        analyticsData: state => state.analytics
      }),
      /**
       * Creating a payload for HTTP request
       * @return {object}
       */
      payload () {
        const source = this.selectedSources.map(source => {
          return source.source
        })
        return {
          endDate: this.dateFilter.endDate,
          startDate: this.dateFilter.startDate,
          starRating: this.starRating,
          dateInterval: this.customLabel(this.dateFilter.startDate, this.dateFilter.endDate),
          businessSlug: this.businessSlug,
          source,
          replyTime: this.replyTime
        }
      },
      chartColumns () {
        const col = [
          {
            type: 'string',
            label: 'Date'
          }
        ]

        const series = {}

        this.selectedSources.forEach((source, index) => {
          col.push({
            type: 'number',
            label: source.label
          })

          series[index] = {color: source.color}
        })
        this.chartOptions.series = series

        this.keyIdx++
        return col
      },
      canFetchData () {
        return this.payload.source.length && (!Array.isArray(this.payload.starRating) || this.payload.starRating.length !== 1 || this.payload.starRating[0] !== null)
      }
    },
    methods: {
      ...mapActions({
        'fetchReviewAnalyticsGraph': `analytics/${FETCH_REVIEW_ANALYTICS_GRAPH}`
      }),
      /**
       * Fetching the review analytics stats
       * @return {void}
       */
      fetchAnalyticsStats () {
        if (this.canFetchData) {
          this.isLoading = true
          this.loadingIndex++
          const payload = JSON.parse(JSON.stringify(this.payload))
          this.fetchReviewAnalyticsGraph(payload)
            .then(() => {
              this.isLoading = true
              this.requestCount++
              this.keyIdx++
              window.events.$emit('dataFetched_ra')
            })
            .then(() => {
              if (this.loadingIndex === this.requestCount) {
                this.isLoading = false
              }
            })
        }
      },
      /**
       * Handle Star Rating Dropdown Filter
       * @param {array} ratingFilter Star Rating to Sort On
       * @return {void}
       */
      handleStarRatingFilter (ratingFilter) {
        this.starRating = ratingFilter
        window.events.$emit('starRatingChanged_rds', ratingFilter)
      },
      sourceToggle (isChecked, source) {
        if (isChecked) {
          this.selectedSources.push(source)
        } else {
          const idx = this.selectedSources.findIndex(s => s.source === source.source)
          if (idx > -1) {
            this.selectedSources.splice(idx, 1)
          }
        }
        window.events.$emit('sourceChanged_rds', this.selectedSources)
      }
    },
    watch: {
      payload (newVal, oldVal) {
        if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
          this.fetchAnalyticsStats()
        }
      }
    }
  }
</script>

<style scoped>
  @import './common.css';

  .bar-chart-total-reviews {
    color: #58595b;
    font-size: 11px;
    font-weight: bold;
    overflow: hidden;
    padding-top: 11px;
  }

  .checkbox-label {
    margin-left: 10px;
    font-size: 11px;
    font-weight: normal;
  }
</style>



// WEBPACK FOOTER //
// src/pages/analytics/reviews/ReviewDetailedStats.vue